import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { UserPlus } from 'lucide-react';

function RegisterPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await register(name, email, password);

    if (result.success) {
      toast.success('¡Cuenta creada exitosamente!');
      navigate('/');
    } else {
      toast.error(result.error || 'Error al crear la cuenta');
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-24">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-4xl font-light text-[#374963] mb-2" data-testid="register-page-title">
            Crear Cuenta
          </h1>
          <p className="text-[#73706e]">¿Ya tienes cuenta? <Link to="/login" className="text-[#785534] hover:underline" data-testid="register-login-link">Inicia sesión</Link></p>
        </div>

        <form onSubmit={handleSubmit} className="mt-8 space-y-6 bg-white p-8 rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.04)]" data-testid="register-form">
          <div className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-[#374963] mb-2">
                Nombre Completo
              </label>
              <input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="w-full px-4 py-3 border border-[rgba(55,73,99,0.1)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#374963]"
                data-testid="register-name-input"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-[#374963] mb-2">
                Correo Electrónico
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 border border-[rgba(55,73,99,0.1)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#374963]"
                data-testid="register-email-input"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-[#374963] mb-2">
                Contraseña (mínimo 6 caracteres)
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                className="w-full px-4 py-3 border border-[rgba(55,73,99,0.1)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#374963]"
                data-testid="register-password-input"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#374963] text-white py-3 rounded-lg hover:bg-[#4A5F7D] transition-colors disabled:opacity-50 flex items-center justify-center space-x-2"
            data-testid="register-submit-button"
          >
            {loading ? (
              <span>Creando cuenta...</span>
            ) : (
              <>
                <UserPlus className="w-5 h-5" />
                <span>Crear Cuenta</span>
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default RegisterPage;